import React, { useState, useEffect, useRef } from "react";
import "../../ConfirmPregnancyForm.css";
import useRazorpay from "react-razorpay";
import configData from "../../config.json";

const ConfirmPregnancyForm = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    number: "",
    email: "",
    area_id: "",
    UPT: "",
    date: ["", ""],
    sonog_date: ["", ""],
    payment_status: "",
    is_report_uploaded: false,
    is_visited: false,
  });

  const [areas, setAreas] = useState([]);
  const [isSaved, setIsSaved] = useState(false);
  const [areaPrice, setAreaPrice] = useState(null);
  const [Razorpay] = useRazorpay();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const hasFetchedAreas = useRef(false);

  // Fetch areas on page load
  useEffect(() => {
    if (!hasFetchedAreas.current) {
      hasFetchedAreas.current = true;

      fetch(`${configData.SERVER_API_URL}/users/get_areas_list`)
        .then((res) => res.json())
        .then((data) => {
          if (data.success && Array.isArray(data.list)) {
            setAreas(data.list);
          } else {
            console.error("Unexpected data format:", data);
          }
        })
        .catch((err) => {
          console.error("Error fetching areas:", err);
        });

      // Load saved form data from localStorage if available
      const savedForm = localStorage.getItem("savedPregnancyForm");
      if (savedForm) {
        setFormData(JSON.parse(savedForm));
      }
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log("Changed:", name, value);
    console.log("Updated formData:", { ...formData, [name]: value });
    console.log("Current payment status:", formData.payment_status);

    if (name === "area_id") {
      const selectedArea = areas.find((area) => area.id === parseInt(value));
      setAreaPrice(selectedArea ? selectedArea.confirm_pregnancy_price : null);
      console.log("Selected Area ID:", value);
    }

    if (name === "date1" || name === "date2") {
      const newDates = [...formData.date];
      newDates[name === "date1" ? 0 : 1] = value;
      setFormData({ ...formData, date: newDates });
    } else if (name === "sonog_date1" || name === "sonog_date2") {
      const newSonogDates = [...formData.sonog_date];
      newSonogDates[name === "sonog_date1" ? 0 : 1] = value;
      setFormData({ ...formData, sonog_date: newSonogDates });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const { full_name, number, email, area_id, UPT, date, sonog_date } =
      formData;

    if (
      !full_name.trim() ||
      !number.trim() ||
      !email.trim() ||
      !area_id ||
      !UPT ||
      !date[0] ||
      !date[1] ||
      !sonog_date[0] ||
      !sonog_date[1]
    ) {
      alert("Please fill all the required fields before proceeding.");
      return;
    }

    try {
      const res = await fetch(
        `${configData.SERVER_API_URL}/users/insert_Confirm_Pregnancy`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            area_id: parseInt(formData.area_id),
          }),
        }
      );

      const data = await res.json();
      if (data.success && data.data?.id) {
        alert("Form saved successfully!");
        setFormData((prev) => ({
          ...prev,
          id: data.data.id,
          //full_name: data.data.full_name || prev.full_name
        }));
        setIsFormSubmitted(true);
      } else {
        alert("Something went wrong while saving the form!");
      }
    } catch (error) {
      console.error("Error saving form:", error);
      alert("Error occurred while saving the form.");
    }
  };

  const handlePayment = async () => {
    try {
      const paymentResponse = await fetch(
        `${configData.SERVER_API_URL}/checkout/getorderId`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ amount: areaPrice * 100, currency: "INR" }),
        }
      );

      const paymentData = await paymentResponse.json();

      if (paymentData.success) {
        const options = {
          key: "rzp_live_5FkwM0dSiSrFis",
          amount: areaPrice * 100,
          currency: "INR",
          name: "Myprega",
          description: "Confirm Pregnancy Payment",
          order_id: paymentData.order_details.id,

          handler: async function (response) {
            alert("Payment Successful!");

            const updatedData = {
              payment_status: "SUCCESS",
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              amount: areaPrice,
              id: formData.id,
            };

            await sendPaymentDetails(updatedData);

            setFormData((prev) => ({
              ...prev,
              ...updatedData,
            }));

            // Redirect  to Thank  You page
            window.location.href = "/thank-you";
          },

          modal: {
            ondismiss: async function () {
              alert("Payment was not completed.");

              const updatedData = {
                payment_status: "PENDING",
                //razorpay_payment_id: "",
                razorpay_order_id: paymentData.order_details.id,
                //razorpay_signature: "",
                amount: areaPrice,
                id: formData.id,
              };

              console.log("Saving after payment success:", updatedData);

              await sendPaymentDetails(updatedData);
            },
          },

          prefill: {
            name: formData.full_name,
            email: formData.email,
            contact: formData.number,
          },
          theme: {
            color: "#3399cc",
          },
        };

        const razorpayInstance = new Razorpay(options);
        razorpayInstance.open();
      } else {
        alert("Payment failed. Please try again!");
      }
    } catch (error) {
      console.error("Error fetching order ID:", error);
      alert("Error occurred while starting the payment.");
    }
  };

  const sendPaymentDetails = async (paymentData) => {
    console.log("Sending payment data:", paymentData);

    try {
      const res = await fetch(
        `${configData.SERVER_API_URL}/users/update_payment_deatails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(paymentData),
        }
      );

      const result = await res.json();
      console.log("Payment update response:", result);

      if (result.success) {
        alert("Payment details saved successfully.");
      } else {
        console.warn("Failed to save payment details.");
      }
    } catch (error) {
      console.error("Error sending payment details:", error);
    }
  };

  return (
    <form className="confirm-pregnancy-form" onSubmit={handleSave}>
      <h2>
        📝 Please fill in these quick details to continue to payment and confirm
        your booking.<br></br>
        This helps us schedule your consultation and sonography at your
        convenience, without any hassle.
      </h2>

      {/* Form fields */}
      <div style={{ paddingBottom: "18px" }}>
        <label>
          <h1>Full Name</h1>
          <p>Please tell us your full name so we know how to address you.</p>
        </label>
        <input
          type="text"
          name="full_name"
          placeholder="Enter your full name"
          value={formData.full_name}
          onChange={handleChange}
          required
        />
      </div>

      <div style={{ paddingBottom: "18px" }}>
        <label>
          <h1>WhatsApp Number (Primary Contact)</h1>
          <p>
            We’ll use this number to confirm your appointments and keep in touch
            via WhatsApp
          </p>
        </label>
        <input
          type="text"
          name="number"
          placeholder="Enter your WhatsApp number"
          value={formData.number}
          onChange={handleChange}
          required
        />
      </div>

      <div style={{ paddingBottom: "18px" }}>
        <label>
          <h1>Email Address</h1>
          <p>
            We’ll send you appointment details and payment confirmation here.
          </p>
        </label>
        <input
          type="email"
          name="email"
          placeholder="Enter your email address"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <div style={{ paddingBottom: "18px" }}>
        <label>
          <h1>Which Area Do You Stay In?</h1>
          <p>This helps us check service availability near you.</p>
        </label>
        <select
          name="area_id"
          value={formData.area_id}
          onChange={handleChange}
          required
        >
          <option value="">E.g. Kothrud, Wakad, Hinjewadi, etc.</option>
          {areas.map((area) => (
            <option key={area.id} value={area.id}>
              {area.name}
            </option>
          ))}
        </select>
      </div>

      <div style={{ paddingBottom: "18px" }}>
        <label>
          <h1>
            Have You Taken a Home Pregnancy Test (UPT) and Got a Positive
            Result?
          </h1>
          <p>Please let us know if your home test showed a positive result.</p>
        </label>
        <select
          name="UPT"
          value={formData.UPT}
          onChange={handleChange}
          required
        >
          <option value="">Select UPT</option>
          <option value="positive">Yes, it was positive</option>
          <option value="negative">No, I haven’t taken a test yet</option>
          <option value="not_sure">I’m not sure</option>
        </select>
      </div>

      <div style={{ paddingBottom: "0px" }}>
        <label>
          <h1>When Would You Prefer to Meet the Gynecologist?</h1>
          <p>
            Choose at least two dates that work best for your first gynecologist
            consultation. We’ll schedule based on your availability.
            <br></br>
            📝 Please make sure the dates you select are at least 1 day after
            your chosen consultation dates, so the doctor’s guidance can be
            followed for the scan.
            <br></br>
            (Preferred Date 1).
          </p>
        </label>
        <input
          type="date"
          name="date1"
          value={formData.date[0]}
          onChange={handleChange}
          required
        />
      </div>

      <div style={{ paddingBottom: "18px" }}>
        <label>
          <p>(Preferred Date 2).</p>
        </label>
        <input
          type="date"
          name="date2"
          value={formData.date[1]}
          onChange={handleChange}
          required
        />
      </div>

      <div style={{ paddingBottom: "0px" }}>
        <label>
          <h1>
            {" "}
            When Would You Prefer to Have Your Pregnancy Confirmation
            Sonography?
          </h1>
          <p>
            Pick at least two dates for your early sonography scan (dating
            scan). We’ll confirm the most suitable one.
            <br></br>
            📝 Please make sure the dates you select are at least 1 day after
            your chosen consultation dates, so the doctor’s guidance can be
            followed for the scan.
            <br></br>
            (Preferred Date 1).
          </p>
        </label>
        <input
          type="date"
          name="sonog_date1"
          value={formData.sonog_date[0]}
          onChange={handleChange}
          required
        />
      </div>

      <div style={{ paddingBottom: "18px" }}>
        <label>
          <p>(Preferred Date 2).</p>
        </label>
        <input
          type="date"
          name="sonog_date2"
          value={formData.sonog_date[1]}
          onChange={handleChange}
          required
        />
      </div>

      <div className="button-group">
        {!isFormSubmitted ? (
          <button onClick={handleSave} type="button">
            Save & Next
          </button>
        ) : (
          <button onClick={handlePayment} type="button">
            Proceed to Payment
          </button>
        )}
      </div>
    </form>
  );
};

export default ConfirmPregnancyForm;
